/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { closeAlert } from '@modules/admin/alert/Alert.dux'
import { useDispatch, useSelector } from 'react-redux'
import { getAlertData } from '@modules/admin/alert/Alert.dux'

import './styles.scss'

export default function Alert(props) {
  const dispatch = useDispatch()
  const alert = useSelector((state) => getAlertData(state))
  const { onClose, timeOut } = props

  useEffect(() => {
    let timer
    if (alert.show && timeOut) {
      timer = setTimeout(closeAlertFn, timeOut)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [alert.show])

  const closeAlertFn = () => {
    if (onClose) onClose()
    dispatch(closeAlert())
  }

  return (
    <div
      className={`alert ${timeOut ? 'fixed' : 'alert'} alert-${alert.type} alert-dismissable ${
        alert.show ? 'fadeIn' : 'fadeOut'
      }`}
    >
      <p>
        <strong>{alert.important}</strong> {alert.text}
      </p>
      {onClose ? (
        <span className="close" onClick={(e) => onClose(e)}>
          &times;
        </span>
      ) : null}
    </div>
  )
}
